import React from "react";
import { PiCoinDuotone, PiCoinsDuotone } from "react-icons/pi";

interface ProductCardProps {
  productName: string;
  productLabel?: string;
  priceLabel: string;
  onClick: () => void;
  credits: number; // Added credits as a prop
}

export function ProductCard({
  productName,
  productLabel,
  priceLabel,
  onClick,
  credits,
}: ProductCardProps) {
  return (
    <div
      className="relative p-4 rounded-md flex flex-col justify-between items-center hover:bg-hover bg-componentBackground border border-border cursor-pointer shadow-md"
      onClick={onClick}
    >
      {/* Product Label (Absolute Position) */}
      {productLabel && (
        <span className="absolute -top-3 right-1 text-xs font-medium text-orange-500 bg-orange-100 border border-orange-300 rounded-lg px-2 py-1 shadow-sm">
          {productLabel}
        </span>
      )}

      {/* Credits Icon and Amount */}
      <div className="flex flex-col items-center mb-4 gap-2">
        <span className="text-lg font-bold">{productName}</span>
        {credits > 300 ? (
          <PiCoinsDuotone size={32} className="text-orange-500 " />
        ) : (
          <PiCoinDuotone size={32} className="text-orange-500 " />
        )}
      </div>

      {/* Price */}
      <span className="text-lg font-semibold text-primary border border-border rounded-lg p-2 bg-background shadow-lg">
        {priceLabel}
      </span>
    </div>
  );
}

interface CardProps {
  title?: string;
  children: React.ReactNode;
  onEdit?: () => void; // Callback for edit button
  isIncomplete?: boolean; // Completion indicator
  credits?: number; // Credits for completion
  className?: string; 

}

export function Card({
  title,
  children,
  onEdit,
  isIncomplete,
  credits,
  className,
}: CardProps) {
  return (
    <div
      className={`bg-componentBackground rounded-xl shadow-md p-4 relative ${
        className ?? ""
      }`}
    >
      {title && (
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 space-y-2 md:space-y-0">
          <h2 className="text-xl font-semibold text-text">{title}</h2>
          <div className="flex flex-col md:flex-row md:items-center md:space-x-2">
            {isIncomplete && credits && (
              <div className="inline-flex items-center gap-1 bg-orange-100 text-orange-500 text-xs px-2 py-1 rounded-lg shadow-sm max-w-max">
                <span>Complete and earn FREE +{credits}</span>
                <PiCoinsDuotone size={16} />
              </div>
            )}
            {onEdit && (
              <button
                onClick={onEdit}
                className="text-sm font-medium text-primary underline hover:text-secondary"
              >
                Update
              </button>
            )}
          </div>
        </div>
      )}
      {children}
    </div>
  );
}
